import { gql, useQuery } from '@apollo/client';
import {
  GetSegmentsQuery,
  GetSegmentsQueryVariables,
} from '../../../__generated__/queries-web';

export const GET_SEGMENTS = gql`
  query GetSegments(
    $first: UnsignedInt!
    $where: SegmentFilterInput
    $orderBy: [SegmentOrderingInput!]
  ) {
    segments(first: $first, where: $where, orderBy: $orderBy) {
      active
      id
      title
      brandKey
      status
    }
    segmentCount
  }
`;

export const useSegments = (
  variables: GetSegmentsQueryVariables,
  skip?: boolean,
) =>
  useQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GET_SEGMENTS, {
    variables,
    skip,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
